<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <span slot="header">搜索</span>
      <el-form :model="search"
               ref="search"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="职位名称"
                          prop="title">
              <el-input placeholder="请输入职位名称"
                        v-model="search.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="发布单位"
                          prop="employer_name">
              <el-input placeholder="请输入发布单位"
                        v-model="search.employer_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="状态"
                          prop="status">
              <el-select multiple
                         v-model="search.status"
                         placeholder="请选择状态">
                <el-option v-for="(value,index) in options.status"
                           :label="value.keyword"
                           :value="value.id"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="日期区间选择"
                          prop="datetimerange">
              <el-date-picker v-model="search.datetimerange"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              align="right"
                              value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetForm('search')">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%"
                @sort-change="onOrderByTable">
        <el-table-column prop="title"
                         label="职位名称"></el-table-column>
        <el-table-column prop="position_strtype"
                         label="职位类型"></el-table-column>
        <el-table-column prop="employer_name"
                         label="发布单位"></el-table-column>
        <el-table-column prop="strstatus"
                         label="状态"></el-table-column>
        <el-table-column prop="unread_resume_count"
                         label="新投递简历数"></el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         sortable="custom"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <router-link :to="'/position/audit-detail/'+scope.row.id+ '?creator='+scope.row.creator">
              <el-button type="text"
                         size="mini">预览
              </el-button>
            </router-link>
            <router-link :to="{path: '/resume/audit-table',query:{id:scope.row.id}}">
              <el-button type="text"
                         size="mini">查看简历
              </el-button>
            </router-link>
            <el-button type="text"
                       size="mini"
                       @click="onForceOfflinePosition(scope.row.id)"
                       v-if="scope.row.status === 1">强制下线
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="onTopPosition(scope.row.id)"
                       v-if="scope.row.status === 1">刷新职位
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@/mixins/table-v1'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        platform: 2, // 客户端平台
        title: null,
        employer_name: null,
        datetimerange: [],
        status: [],
        sort_by_created_at: null,
      },
      // 搜索字段申明
      searchFieldType: {
        sort_by_created_at: Number,
        platform: Number,
        status: {0: Number, 1: Number, 2: Number},
      },
      options: {
        status: [
          {id: 1, keyword: '已发布'},
          {id: 2, keyword: '已下线'},
          {id: 5, keyword: '审核不通过'},
        ],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions(['getPositionTable', 'topPosition']),

    getSearchParams () {
      if (this.search.status.length === 0) {
        this.search.status = [1, 2, 5]
      }
      return this.search
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getPositionTable', params)
    },
    onForceOfflinePosition (id) {
      this.$confirm('强制下线将邮件通知用户,请确认操作。', '提示', {
        confirmButtonText: '强制下线',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        return request.common('forceOfflinePosition', id).then((res) => {
          this.$message({
            showClose: true,
            message: '强制下线成功',
            type: 'success',
          })
          this.onSearch()
        })
      })
    },
    onTopPosition (id) {
      return request.common('topPosition', id).then((res) => {
        this.$message({
          showClose: true,
          message: '刷新职位成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      console.log(this.search)
    },
    onOrderByTable (val) {
      if (val.order === 'descending') {
        this.search.sort_by_created_at = 2
      } else {
        this.search.sort_by_created_at = 1
      }
      this.onSearch()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/position/pages/PositionAuditTable.vue